var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "manage-activities-domain-modal",
        title: "Déplacer les activités",
        scrollable: "",
        "hide-footer": "",
      },
    },
    [
      _c(
        "b-alert",
        { attrs: { variant: "warning", show: _vm.disableDomain } },
        [
          _vm._v("\n    Avant de pouvoir désactiver le domaine "),
          _c("b", [_vm._v(_vm._s(_vm.domain?.dac_label))]),
          _vm._v(", vous avez "),
          _c("b", [_vm._v(_vm._s(_vm.activities.length))]),
          _vm._v(" activité(s) à déplacer.\n  "),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _vm._v("\n    Déplacer toutes les activités vers\n    "),
          _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.moveActivities(true)
                },
              },
            },
            [
              _c(
                "b-input-group",
                { staticClass: "mt-3" },
                [
                  _c("b-form-select", {
                    attrs: {
                      options: _vm.getDomainsExceptSelected,
                      "value-field": "dac_id",
                      "text-field": "dac_label",
                    },
                    model: {
                      value: _vm.selectedDomain,
                      callback: function ($$v) {
                        _vm.selectedDomain = $$v
                      },
                      expression: "selectedDomain",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "b-input-group-append",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type: "submit",
                            disabled: !_vm.selectedDomain,
                            variant: "primary",
                          },
                        },
                        [_vm._v("Envoyer")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center", staticStyle: { margin: "5px 0" } },
        [_vm._v("Ou individuellement")]
      ),
      _vm._v(" "),
      _c("b-table", {
        attrs: { fields: _vm.fields, items: _vm.activities },
        scopedSlots: _vm._u([
          {
            key: "cell(actions)",
            fn: function (row) {
              return [
                _c("b-form-select", {
                  attrs: {
                    options: _vm.getDomainsWithEmptyOption,
                    "value-field": "dac_id",
                    "text-field": "dac_label",
                  },
                  model: {
                    value: row.item.dac_id,
                    callback: function ($$v) {
                      _vm.$set(row.item, "dac_id", $$v)
                    },
                    expression: "row.item.dac_id",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text-center",
          staticStyle: { position: "sticky", bottom: "0" },
        },
        [
          _c(
            "b-button",
            {
              attrs: {
                disabled: !_vm.checkForIndividualMove,
                variant: "primary",
                type: "submit",
              },
              on: {
                click: function ($event) {
                  return _vm.moveActivities(false)
                },
              },
            },
            [_vm._v("Envoyer")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }